module.exports = __webpack_public_path__ + "fec997000e481e4e6f3e36b92a62a780.svg";